import { unref } from 'vue';
import {
  getLatchkeyList,
  getViewStateLatchkeyData,
  mutateTieredPrice,
} from '../composables/utils.bcom';
/**
 * Parse product response into price data for bcom
 * @param {ProductBcom} product
 * @param { UiKillswitchesBcom } uiKillSwitches
 * @param { PriceParserOptions } options
 * @returns {TraitPriceBcom}
 */

const parser = (product, uiKillSwitches = {
  isConsolidatedPhase3Enabled: false,
  isColorwayPromosEnabled: false,
  ccfpEnabled: false,
}, options = { iShip: false, disableKlarna: false }) => {
  const unrefedProduct = unref(product);
  const latchkeyList = getLatchkeyList(unrefedProduct);
  const isLatchkeyProduct = latchkeyList.length > 1;
  const latchkeyData = getViewStateLatchkeyData(product, uiKillSwitches, latchkeyList);
  const isConsolidatedMaster = !!unrefedProduct.detail?.flags?.consolidatedMaster;
  const isConsolidatedMasterLatchkeySelect = isConsolidatedMaster && isLatchkeyProduct;
  const isColorwayOffers = uiKillSwitches.isColorwayPromosEnabled && !unrefedProduct.detail?.flags.masterProduct;
  const isMasterProduct = !!product?.detail?.flags?.masterProduct;
  const isCCFP = !product?.detail?.flags?.masterProduct && uiKillSwitches.ccfpEnabled && product.ccfp?.ccfpEligible;
  const klarnaEligible = !!(unrefedProduct.detail?.flags?.klarnaEligible && !options.iShip && !options.disableKlarna);
  if (unrefedProduct?.relationships?.upcs) Object.values(unrefedProduct?.relationships?.upcs).forEach((upc) => mutateTieredPrice(upc));
  if (unrefedProduct?.traits?.colors?.colorMap) Object.values(unrefedProduct?.traits?.colors?.colorMap).forEach((color) => mutateTieredPrice(color));

  const {
    traits, relationships, pricing, ccfp, department,
  } = unrefedProduct;

  return {
    traits,
    relationships,
    pricing,
    isConsolidatedMaster,
    latchkeyData,
    isMasterProduct,
    isLatchkeyProduct,
    isColorwayOffers,
    isConsolidatedMasterLatchkeySelect,
    isCCFP,
    ccfp,
    klarnaEligible,
    department,
  };
};

export default parser;
